import React from "react";
import PropTypes from "prop-types";
import { defaultProps } from "recompose";
import SweetAlert from "sweetalert2/dist/sweetalert2"
import { ValidatorForm } from "react-material-ui-form-validator";



import PathManager from "../../helpers/PathManager";
import Rules from "../../config/rules";
import SnackbarCloseButton from  "../layout/button/SnackbarCloseButton";

import 'sweetalert2/src/sweetalert2.scss';
import StringHelper from "../../helpers/StringHelper";

class AbstractExtranetRegisterStepper extends React.Component {

    /** Attributes **/


    /** State **/
    state = {
        parentId: this.props.parentData ? this.props.parentData.parentId : null
    }

    /** Lifecycle callbacks **/

    constructor(props) {

        // send props to parent constructor
        super(props);

        // form ref
        this.mainForm = React.createRef();

        // path manager
        this.pathManager = new PathManager(this.props.history);

    }

    componentDidMount() {

        let data = this.props.data === null || this.props.data === undefined ? {} : this.props.data;

        this.setState(data);

        /**
         * ADDING COMMON VALIDATION RULES
         */
        // Check if date is before now
        ValidatorForm.addValidationRule('isBeforeNow', Rules.isBeforeNow);
        ValidatorForm.addValidationRule('isValidDate', Rules.isValidDate);
    }

    componentWillUnmount() {
        ValidatorForm.removeValidationRule('isBeforeNow');
        ValidatorForm.removeValidationRule('isValidDate');
    }

    /** functions **/

    arrayStateUpdated = (arrayName, idx, name, value) => {
        let tmpArr = this.state[arrayName];

        // If not data create them
        if (!tmpArr || tmpArr.length === 0) {
            return [{[name]: value}];
        }

        tmpArr[idx][name] = value;
        return tmpArr;
    }


    /** Events **/
    handleSaveStep = (data, callBack) => {

        // this.setState({'loading': true});

        // var _that = this;
        // const callBackCloseLoading = function (data) {
        //     _that.setState({'loading': false});
        //     callBack(data);
        // }

        // Send data using fetch
        /*FetchUtil.send(
            Settings.requests.sinistres.sinistreEdition,
            this.state,
            callBackCloseLoading,
            (error) => {
                this.loadDataKo('une erreur est survenue lors de la sauvegarde de l\'étape', error);
            },
            'POST',
            true
        );*/
    }

    handleNext = () => {
        const _that = this;

        // remove confirm dialog (case if nextWithValidation)
        this.handleCancel();

        // Check if has upload and if they are valid
        if (!this.isUploadFormValid()) {
            // Scroll to top most error
            setTimeout(function () {
                _that.scrollToError()
            }, 200);
            return false;
        }
        this.mainForm.current.isFormValid(false).then(function (value) {

            // if form is valide, save and to to next step
            if (value === true) {

                if (_that.props.nbStep === _that.props.activeStep) {
                    // if final step ask for validation final submit
                    _that.validation();
                } else {
                    // send form data
                    // use _that.state instead ??? old = _that.formToData()
                    if(window.location.pathname.indexOf('sinistres_en_ligne') !== -1) {
                        _that.handleSaveStep(_that.state, _that.props.handleNext);
                    }
                    else {
                        _that.props.handleNext(_that.state);
                    }

                }
            } else {
                // Scroll to top most error
                _that.scrollToError();
            }
        });
    }

    loadStepInfoFromId = (skipLoadStepInfoFromId) => {

        // if ask to skipLoadStepInfoFromId do not load, mean it is done in the step manually
        if (skipLoadStepInfoFromId === true) return;

        if (this.props.activeStep === 0) {

            // Load data from parent id
            if (!this.props.data && !this.props.id && this.props.parentData && this.props.parentData.parentId) {

                /*this.setState({loading: true});

                // get adata from a request fetch and update the state with sinistre datas
                this.doRequest(
                    Settings.requests.sinistres.sinistreSuite,
                    {
                        parentId: this.props.parentData.parentId,
                        fullData: this.props.stepName === Settings.sections.it,
                    },
                    'une erreur est survenue lors de la restitution des informations',
                    true,
                    true,
                );*/

            } else {

                // Load data from id
                if (!this.props.data && !this.state.id && this.props.id) {

                    /*this.setState({loading: true});

                    // get adata from a request fetch and update the state with sinistre datas
                    this.doRequest(
                        Settings.requests.sinistres.sinistre,
                        {id: this.props.id},
                        'une erreur est survenue lors de la restitution des informations',
                        false,
                        true,
                    );*/

                }
            }
        }
    }

    validation = () => {

        const _that = this;

        // Add extra info to the next steps (by cloning it else status is updated in real state !)
        let data = JSON.parse(JSON.stringify(this.state));
        data.html = JSON.stringify(this.html);
        // close the sinistre
        data.status = 1;

        SweetAlert.fire({
            title: 'Validation de la déclaration',
            html: "Vous êtes sur le point d'envoyer votre dossier<br/> aux services d’Uniprévoyance.<br/>Une fois envoyé, le dossier ne sera plus modifiable.<br/><br/>Confirmez-vous l'envoi ?",
            type: 'question',
            reverseButtons: true,
            showCancelButton: true,
            confirmButtonColor: '#3a6f84',
            confirmButtonText: 'Envoyer',
            cancelButtonColor: '#d33',
            cancelButtonText: 'Annuler',
            allowOutsideClick: false,
        }).then((result) => {
            if (result.value) {

                /*SweetAlert.fire({
                    title: 'Envoi en cours',
                    html: '<img alt="loading" width="100" height="100" src="' + process.env.PUBLIC_URL + '/assets/img/loader.gif"><br>Veuillez patienter, votre déclaration est en cours de transmission aux services concernés.',
                    showConfirmButton: false,
                    allowOutsideClick: false,
                });

                FetchUtil.send(
                    // Settings.upload.sinistres.url+'/ged.php',   // old one used with Remy Module
                    Settings.upload.sinistres.pdf, // New one developped by David (PHP & Symfony)
                    data,
                    () => {
                        FetchUtil.send(
                            Settings.requests.sinistres.sinistreEdition,
                            data,
                            _that.doSweetOk,
                            _that.doSweetError
                        )
                    },
                    _that.doSweetError,
                    'POST',
                    true
                );*/
            }
        })
    }

    doSweetError = () => {
        SweetAlert.fire({
            title: 'Une erreur est survenue',
            text: 'Une erreur est survenue lors de la sauvegarde de votre déclaration, merci de réessayer plus tard',
            type: 'error',
            confirmButtonText: 'Continuer',
            confirmButtonColor: '#EF595D',
        });
    }

    doSweetOk = () => {
        SweetAlert.fire({
            title: 'Dossier transmis avec succès à Uniprévoyance',
            text: 'Votre déclaration a été enregistrée, elle sera traitée par nos services dans les meilleurs délais',
            type: 'success',
            confirmButtonText: 'Continuer',
            confirmButtonColor: '#3a6f84',
            allowOutsideClick: false
            // Then redirect if click 'Continuer'
        }).then((response) => {
            console.log(response)
            if (response.confirm) {
                this.pathManager.goToBasedOnSection(this.state.typeSinistre, '', '-home');
            }
        })
    }

    handleCancel = () => {
        this.setState({showConfirm: false});
    }

    handleBack = () => {
        if (this.state.id && this.state.id !== '')
            this.handleSaveStep(this.state, this.props.handleBack);
        else
            this.props.handleBack();
    }

    handleBackHistory = () => {
        this.props.handleBack(this.state);
    }

    handleSave = () => {

        const _that = this;

        // Can't save if declarant is not set
        if (!this.state.idDeclarant || this.state.idDeclarant === '') return;

        // do save then display message
        this.handleSaveStep(this.state, function () {
            SweetAlert.fire({
                title: 'Sauvegarde effectuée avec succès',
                text: 'Vous pourrez continuez votre déclaration ultérieurement',
                type: 'success',
                confirmButtonText: 'Continuer',
                allowOutsideClick: false,
                confirmButtonColor: '#3a6f84',
                // Then redirect if click 'Continuer'
            }).then((result) => {
                if (result.value) {
                    _that.pathManager.goToBasedOnSection(_that.state.typeSinistre, '', '-home');
                }
            })
        });

    }

    scrollToError = () => {
        const element = document.querySelector('div[class*="error"]');
        if (element) {
            var rect = element.getBoundingClientRect();
            window.scrollTo(0, window.scrollY + rect.top - 100);
        }
    }

    doRequest = (url, data, errmsg, loading = true, doErr = true) => {
        // set loader
        if (loading === true) this.setState({'loading': loading});
        // Send data using fetch
        /*FetchUtil.send(
            url,
            data,
            this.loadData,
            (error) => {
                // Manage if id doesnt exist in database redirect to home
                if (error.alert && error.alert.indexOf('not found in method getSinistre') !== -1) {
                    this.pathManager.goToBasedOnSection(this.state.typeSinistre, '', '-home');
                    return;
                }
                // Manage the error
                doErr === true ? this.loadDataKo(errmsg, error) : console.log(errmsg);
            },
            'POST',
            true
        );*/
    }

    loadData = (data) => {
        // add loading
        data.loading = false;
        // set that data has been loaded
        data.isLoaded = true;

        //Special case format retored values
        if (data.ssNum)
            data.ssNum = StringHelper.formatSSNum(data.ssNum);

        // SECURITY : CHECK IF SECTION MATCH WITH DATABASE ELSE REDIRECT
        if (data.typeSinistre && data.typeSinistre !== this.props.stepName) {
            console.log('Redirect : Trying to access ' + data.typeSinistre + ' from ' + this.props.stepName);
            this.pathManager.goTo('sinistres');
        }

        // change all states
        this.setState(data);
    }

    loadDataKo = (message, error) => {
        // hide loader
        this.setState({
            'loading': false,
            'isLoaded': true,
        });

        // if error has error as key display it
        this.showMessage(error.error ? error.error : message, 'error');
    }

    showMessage = (message, variant) => {
        this.props.enqueueSnackbar(
            message,
            {
                variant: variant,
                action: (key) => (<SnackbarCloseButton variant={variant} closeSnackbar={() => {
                    this.props.closeSnackbar(key)
                }}/>)
            }
        );
    }

    /** Data functions **/

}

AbstractExtranetRegisterStepper.propTypes = {
    activeStep: PropTypes.number,
    handleNext: PropTypes.func,
    handleBack: PropTypes.func
}

AbstractExtranetRegisterStepper.withDefaultProps = defaultProps({
    activeStep: 0,
    handleNext: () => {},
    handleBack: () => {}
})
export default AbstractExtranetRegisterStepper;